import { render } from "./CZLastAcutalMeterReadGas.vue?vue&type=template&id=b284f2e0&scoped=true&ts=true"
import script from "./CZLastAcutalMeterReadGas.vue?vue&type=script&lang=ts"
export * from "./CZLastAcutalMeterReadGas.vue?vue&type=script&lang=ts"

import "./CZLastAcutalMeterReadGas.vue?vue&type=style&index=0&id=b284f2e0&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b284f2e0"]])

export default __exports__